<template>
    <div class="d-flex flex-row align-items-center justify-content-center header">
        <router-link to="/"><img src="@/assets/img-siu/primary-logo-siu-white.png" style="height:35px;"></router-link>
    </div>
</template>
<script>
export default {
    name: 'Header'
}
</script>